import React, { useState } from "react";
import UserInfoModal from "./UserInfoModal";
import { uuidv4 as uuid } from "@firebase/util";

export default function UserListing({ data, level, community }) {
  var users = "";

  level > 3
    ? (users = data.filter(
        (user) =>
          user.data().userTypeNumber < level &&
          user.data().communitySlug == community
      ))
    : (users = data.filter(
        (user) =>
          user.data().userTypeNumber < level &&
          user.data().community == community
      ));

  return (
    <>
      <div className="dashboard_heading">
        <div style={{ flex: 1, margin: "0.5em 0", fontSize: 22 }}>
          Join Date
        </div>
        <div style={{ flex: 1, margin: "0.5em 0", fontSize: 22 }}>Name</div>
        <div style={{ flex: 1, margin: "0.5em 0", fontSize: 22 }}>
          Community
        </div>
        <div style={{ flex: 1, margin: "0.5em 0", fontSize: 22 }}>Role</div>
      </div>

      {users.map((user, i) => {
        const [role, setRole] = useState(user.data().userTypeName);
        const [community, setCommunity] = useState(user.data().community);

        // Convert Firebase timestamp to JavaScript Date object
        let dateCreated = new Date(user.data().dateCreated.toDate());

        // Format the date as you like
        let formattedDate = dateCreated.toLocaleDateString("en-US");

        return (
          <div key={i}>
            <div
              type="button"
              data-bs-toggle="modal"
              data-bs-target={"#exampleModal" + i}
              className="btn dashboard_datarow"
            >
              <div>{formattedDate}</div>
              <p
                style={{
                  flex: 1,
                  margin: "5px 0",
                }}
              >
                {user.data().name.given_name +
                  " " +
                  user.data().name.family_name}
              </p>
              <p style={{ flex: 1, margin: "5px 0" }}>{community}</p>

              <p style={{ flex: 1, margin: "5px 0" }}>{role}</p>
            </div>
            <UserInfoModal
              role={role}
              setRole={setRole}
              community={community}
              setCommunity={setCommunity}
              id={user.id}
              user={user.data()}
              index={i}
              level={level}
            />
          </div>
        );
      })}
    </>
  );
}
